module.exports = __webpack_public_path__ + "static/media/eye-crossed.046540f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eye-crossed.svg
// module id = 646
// module chunks = 0